import { TableCellComponentProps } from '@/shared/types/table';
import { cn } from '@/shared/utils/cn';
import {
  getTableCellClasses,
  getTableCellProps,
  handleCellClick,
  getContentAlignClass,
  isFlexColumn,
} from '../../utils/cellStyles';

export const SkeletonCell = ({
  column,
  className,
  state = 'default',
  onCellFocus,
  stickyLeft = 0,
  isLastLocked = false,
  isRowEditing,
  hasColumnMaxWidthAuto = false,
}: TableCellComponentProps) => {
  const baseClasses = getTableCellClasses(
    state,
    className,
    column.locked,
    isLastLocked,
    undefined,
    isRowEditing,
    false,
    column.width !== undefined || isFlexColumn(column, hasColumnMaxWidthAuto)
  );
  const cellProps = getTableCellProps(column, stickyLeft, undefined, false, hasColumnMaxWidthAuto);

  const hasFixedWidth = column.width !== undefined || isFlexColumn(column, hasColumnMaxWidthAuto);
  const alignClass = getContentAlignClass(column.contentAlign);

  return (
    <td className={baseClasses} {...cellProps} onClick={(e) => handleCellClick(e, onCellFocus)}>
      <div
        className={cn(
          'ui-flex ui-h-full ui-items-center',
          alignClass,
          hasFixedWidth && 'ui-min-w-0 ui-overflow-hidden'
        )}
      >
        <div
          className="ui-h-[14px] ui-w-full ui-animate-pulse ui-rounded-control-pill"
          style={{
            background: 'linear-gradient(to right, #d1d1d1, rgba(107, 107, 107, 0.1))',
          }}
        />
      </div>
    </td>
  );
};
